module.exports = __webpack_public_path__ + "static/media/social-twitter.adf53d59.svg";